import {
    ADD_ATTRIBUTE,
    REMOVE_ATTRIBUTE,
    SET_ATTRIBUTES,
    UPDATE_ATTRIBUTE
} from "../actions/attributesToRetrieveActions";

export default function (state = [], action) {
    switch (action.type) {
        case ADD_ATTRIBUTE:
            return [...state, action.attributeToRetrieve];
        case REMOVE_ATTRIBUTE:
            return state.filter((attributeToRetrieve) => attributeToRetrieve !== action.attributeToRetrieve);
        case SET_ATTRIBUTES:
            return action.attributesToRetrieve;
        case UPDATE_ATTRIBUTE:
            return [...state.map((attribute) => {
                if (action.name === attribute.name) {
                    attribute = {...attribute, [action.attribute]: action.value};
                    return attribute;
                }
                return attribute;
            })];
        default:
            return state;
    }

}